export default [
  {
    date: "March 2023 - Present",
    designation: " Freelance Web developer",
    companyName: "Freelancing",
    location: "Pretoria, South Africa",
    description: [ "Designed mobile-first layouts for responsive web design, accommodating a variety of devices and screen sizes.",
    "Developed prototype designs through wire framing tools like figma before beginning coding work on projects.",
    "Utilised modern web technologies such as HTML5, CSS3, JavaScript, and React to develop custom solutions for diverse industries."

    ]
  },
  {
    date: "March 2024 - March 2024",
    designation: "Web developer facilitator",
    companyName: "AfricaKidsCode",
    location: "Mpumalanga, Volkrust",
    description: [ "Introduced students to technopreneurship and design thinking, and guided them in applying these principles to a given problem statement. Students were then able to build their solution using HTML, CSS, and Bootstrap with my assistance.",
    "Enhanced students engagement by incorporating interactive activities and group discussions in program sessions, promoting collaboration and teamwork.",
    "Enhanced program effectiveness by collaborating with colleagues to review and revise curriculum content regularly."
    ]
      
  },
  {
    date: "June 2023 - December 2023",
    designation: "Software developer trainee",
    companyName: "Mlab South Africa",
    location: "Pretoria, Lynwood",
    description: [ "Utilised agile methodologies to facilitate rapid development cycles and adapt quickly to changing requirements.",
    "Presented progress reports during team meetings, communicating challenges faced and lessons learned effectively.",
    "Utilised modern technologies such as HTML5, CSS3, JavaScript, React, React Native,  Firebase, SQLite, Node.js and Figma."
      
    ]
      
  },

];
